import { buildStrapiUrl } from '../utils/strapi-url';
import { fetchWithRetry } from './fetch-with-retry';

export async function fetchAllCategories(locale: string = 'en') {
  try {
    const params = new URLSearchParams({ locale });

    const res = await fetchWithRetry(
      buildStrapiUrl('/api/web/categories', params),
      {
        next: {
          revalidate: 1800,
          tags: [`categories:${locale}`],
        },
      },
    );
    if (!res.ok) {
      throw new Error('Failed to fetch content hub items');
    }
    const data = await res.json();
    return data.data || [];
  } catch (error) {
    console.error('Error fetching content hub items:', error);
    return [];
  }
}
